import { t } from '@/common/utils/translations'

export function getPageReloadConfirmTitle(): string {
  return t('dialogs.pageReloadTitle')
}

export function isPageReloadShortcut(event: KeyboardEvent): boolean {
  if (event.key === 'F5') return true
  if (event.code !== 'KeyR') return false
  return Boolean(event.ctrlKey || event.metaKey)
}

export function buildPageReloadConfirmMessage(hasOpenForms: boolean): string {
  if (hasOpenForms) {
    return t('dialogs.pageReloadMessageWithForms')
  }
  return t('dialogs.pageReloadMessage')
}

export function hasOpenPlatformForms(input: {
  openTabIds?: readonly string[]
  dialogIds?: unknown[]
}): boolean {
  if ((input.dialogIds?.length ?? 0) > 0) return true
  return (input.openTabIds?.length ?? 0) > 0
}

export function shouldConfirmPageReload(input: {
  routeName?: string | symbol | null
  openTabIds?: readonly string[]
  dialogIds?: unknown[]
}): boolean {
  if (String(input.routeName ?? '') === 'signin') return false
  return hasOpenPlatformForms(input)
}

export function resolveOpenTabIdsForReloadGuard(input: {
  tabIdsOrdered?: readonly string[]
  currentPageId?: string | null
  routeName?: string | symbol | null
}): string[] {
  const ordered = input.tabIdsOrdered ?? []
  if (ordered.length > 0) return [...ordered]

  const routeName = String(input.routeName ?? '')
  if (routeName !== 'platform' && routeName !== 'document') return []

  const currentPageId = String(input.currentPageId ?? '').trim()
  if (!currentPageId || currentPageId === 'home') return []

  return [currentPageId]
}

/** HTML-форма уходит на другой origin. */
export function isCrossOriginFormAction(action: string, pageOrigin: string): boolean {
  const raw = action.trim()
  if (!raw) return false

  try {
    const target = new URL(raw, pageOrigin)
    const page = new URL(pageOrigin)
    return target.origin !== page.origin
  } catch {
    return false
  }
}
